import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import ProcessSteps from '../components/ProcessSteps';
import Newsletter from '../components/Newsletter';
import LogoCarousel from '../components/LogoCarousel';
import SEO from '../components/SEO';

import Scene from '../components/3d/Scene';

const HomePage: React.FC = () => {
  return (
    <main style={{ position: 'relative', zIndex: 1 }}>
      <Scene />
      <SEO
        title="Custom Software Development | UPTREND Systems"
        description="Custom software that solves real problems. We build tailored solutions for your unique business workflows - from integrations to full-scale platforms. Based in Whitby, Ontario."
        keywords="custom software development, business software solutions, tailored applications, system integrations, workflow automation, Ontario software developers, Whitby custom development"
        canonicalUrl="/"
        pageType="home"
      />
      <div id="hero-section">
        <Hero />
      </div>
      <div id="brands-section">
        <LogoCarousel
          columnCount={5}
          title="Trusted by Industry Leaders"
          subtitle="Our custom software solutions are powering businesses across diverse sectors"
        />
      </div>
      <div id="features-section">
        <Features />
      </div>
      <div id="process-section">
        <ProcessSteps />
      </div>
      <div id="newsletter-section">
        <Newsletter />
      </div>
    </main>
  );
};

export default HomePage;